exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/core/containers/app/app.scss
// module id = ../../../../../src/app/core/containers/app/app.scss
// module chunks = main